const setTabs = ({ commit }, tabs) => {
  commit('SET_TABS', tabs);
};

const setActiveTab = ({ commit }, tabs) => {
  commit('SET_ACTIVE_TAB', tabs);
};

const setActiveVehicleIdentificationTab = ({ commit }, tab) => {
  commit('SET_ACTIVE_TAB_IDENTIFICATION', tab);
};

export default {
  setTabs,
  setActiveTab,
  setActiveVehicleIdentificationTab
};
